import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { SelectionId } from 'src_common/common/websocket2/id/WebsocketId';
import { getHorseRacingRunner } from 'src/domains/sportsbook/webview/components/raceSummary/RaceSummaryRow';
import { LazyImageSilk } from 'src/domains/sportsbook/webview/components/lazyImage/LazyImageSilk';
import {
    JockeyAndTrainerDetailsBox,
    RunnerCell,
    RunnerCellDetails,
    SelectionWrapper,
    SilkCellRaceBox,
} from 'src/domains/sportsbook/webview/components/raceSliderItemV1/horseRacing/cardBodyItem/CardBodyItem.style';
import { WidgetSilk } from 'src/domains/sportsbook/webview/components/nextRaces/raceBoxSelection/WidgetSilk';

interface CardBodyItemPropsType {
    selectionId: SelectionId;
    specialEvent?: boolean;
}

export const CardBodyItem = observer('CardBodyItem', ({ selectionId, specialEvent }: CardBodyItemPropsType) => {
    const selection = selectionId.getModel();
    const market = selection?.marketId2.getModel() ?? null;

    if (selection === null || market === null) {
        return null;
    }

    const isUnnamedFavourite = selection.templateId === 'unnamed-favourite';
    const silkUrl = selection.metaDataSilkUrl ?? '';
    const silkAltDesc = selection.metaDataSilk ?? '';

    const runner = getHorseRacingRunner(selection, isUnnamedFavourite);

    if (specialEvent === true) {
        return (
            <>
                <WidgetSilk selectionId={selectionId} />

                <RunnerCellDetails>{runner}</RunnerCellDetails>

                <SelectionWrapper
                    borderLeft={true}
                    selectionId={selectionId}
                />
            </>
        );
    }

    return (
        <>
            <RunnerCell>
                <SilkCellRaceBox>
                    <LazyImageSilk
                        alt={silkAltDesc}
                        imgBase={{
                            src: silkUrl,
                            optimizeOptions: {
                                quality: 85,
                                width: 64,
                            },
                        }}
                    />
                </SilkCellRaceBox>

                <JockeyAndTrainerDetailsBox
                    selection={selection}
                    isUnnamedFavourite={isUnnamedFavourite}
                />
            </RunnerCell>

            <SelectionWrapper
                borderLeft={true}
                selectionId={selectionId}
            />
        </>
    );
});
